import { createStore } from "vuex";

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem("user")) || null,
    role: localStorage.getItem("role") || null,
    token: localStorage.getItem("token") || null,
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.user,
    userRole: (state) => state.role,
    isAdmin: (state) => state.role === "admin",
    isManager: (state) => state.role === "manager",
    isTalent: (state) => state.role === "talent",
    isUser: (state) => state.role === "user",
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      } else {
        localStorage.removeItem("user");
      }
    },
    setRole(state, role) {
      state.role = role;
      if (role) {
        localStorage.setItem("role", role);
      } else {
        localStorage.removeItem("role");
      }
    },
    setToken(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem("token", token);
      } else {
        localStorage.removeItem("token");
      }
    },
    logout(state) {
      state.user = null;
      state.role = null;
      state.token = null;
      localStorage.removeItem("user");
      localStorage.removeItem("role");
      localStorage.removeItem("token");
    },
  },
  actions: {
    login({ commit }, { user, token }) {
      commit("setUser", user);
      commit("setToken", token);
      if (user.role && user.role.length > 0) {
        commit("setRole", user.role[0]);
      }
    },
    logout({ commit }) {
      commit("logout");
    },
    updateUser({ commit }, user) {
      commit("setUser", user);
    },
  },
  modules: {},
});
